import React from "react";
// import { FaCheckCircle } from "react-icons/fa";
import { formatCurrency } from "ultils/currency-formatter";
import { formatDate } from "ultils/date-formatter";

interface UnitTileProps {
  unit: any;
  activeTenant: any;
  openEditModal: (unit: any) => void;
  addTenantClicked: (unit: any) => void;
  editTenantClicked: (unit: any) => void;
  selectTenantClicked: (unit: any) => void;
}

const UnitTile: React.FC<UnitTileProps> = ({
  unit,
  activeTenant,
  openEditModal,
  addTenantClicked,
  editTenantClicked,
  selectTenantClicked,
}) => {
  return (
    <div style={{ marginBottom: "20px" }} className="tile">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2>Unit {unit.name + " " + unit.streetAddress}</h2>{" "}
        {unit.isRented ? (
          <span className="status-badge paid">Rented</span>
        ) : (
          <span className="status-badge not-paid">Not Rented</span>
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <p>Rent being Paid: {formatCurrency(unit.actualRent)}</p>
          <p>Rent Kept: {formatCurrency(unit.rentKept)}</p>
        </div>
        {unit.activeTenant !== null && unit.activeTenant !== undefined && (
          <div style={{ width: "30%" }}>
            <h5>Active Tenant</h5>
            <p>
              {(unit.activeTenant.active ? "🟢" : "🔴") +
                " " +
                unit.activeTenant.firstName +
                " " +
                unit.activeTenant.lastName +
                " makes " +
                formatCurrency(unit.activeTenant.income) +
                " a year. Lease started on: " +
                formatDate(unit.activeTenant.leaseStartDate)}
            </p>
          </div>
        )}
      </div>
      <p>{unit.description}</p>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <button className="btn" onClick={() => openEditModal(unit)}>
          Edit
        </button>
        {unit.tenants.length === 0 ? (
          <>
            <button onClick={() => selectTenantClicked(unit)} className="btn">
              Select a Tenant
            </button>
          </>
        ) : (
          <>
            <button onClick={() => editTenantClicked(unit)} className="btn">
              Edit Tenant
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default UnitTile;
